var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8V10.6122C8.5 11.1633 7.85724 11.4644 7.43388 11.1116L3.09921 7.49934C2.78737 7.23948 2.78737 6.76052 3.09921 6.50066L7.43388 2.88843C7.85724 2.53563 8.5 2.83668 8.5 3.38778V6H12.5C14.6217 6 16.6566 6.84285 18.1569 8.34315C19.6571 9.84344 20.5 11.8783 20.5 14C20.5 16.1217 19.6571 18.1566 18.1569 19.6569C16.6566 21.1571 14.6217 22 12.5 22H9.5C8.94772 22 8.5 21.5523 8.5 21C8.5 20.4477 8.94772 20 9.5 20H12.5C14.0913 20 15.6174 19.3679 16.7426 18.2426C17.8679 17.1174 18.5 15.5913 18.5 14C18.5 12.4087 17.8679 10.8826 16.7426 9.75736C15.6174 8.63214 14.0913 8 12.5 8H8.5Z",
    fill: "#52525B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.522528e414fb02c294c132d93201c785.svg";
export { ForwardRef as ReactComponent };